module.exports = __webpack_public_path__ + "fdd37c7285e14e68216c29c374c845a2.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/user.svg
// module id = 444
// module chunks = 0